import React, { useEffect, useState } from 'react';
import { Button } from '../root/components/buttons/Button';
import { Spinner } from '../root/components/Spinner';
import { Link } from '../root/components/Link';
import styles from './Fallback.module.scss';

const TIMEOUT_MS = 20000;

const Error = () => (
  <span className={styles.error}>
    An error occurred while loading the page. Please&nbsp;
    <Button onClick={() => window.location.reload()} dataTrackLabel="Fallback Timeout" dataTrackLocation="Fallback" text={'refresh your browser.'} />
  </span>
);

export const Fallback: React.FC = () => {
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsError(true);
    }, TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ height: '100vh', width: '100vw', background: 'white' }}>
      {isError && <Error />}
      {!isError && <Spinner visible={true} />}
    </div>
  );
};

export default Fallback;
